import { NgModule } from '@angular/core';

import { SharedModule } from '../../shared.module';
import { BatchAddProductDialogComponent } from './batch-add-product/batch-add-product-dialog.component';
import { BatchAllocateDialogComponent } from './batch-allocate-dialog/batch-allocate-dialog.component';
import { BatchSelectComponent } from './batch-select/batch-select.component';
import { BatchStopIconComponent } from './batch-stop-icon/batch-stop-icon.component';
import { NewBatchDialogComponent } from './new-batch-dialog/new-batch-dialog.component';
import { ProductSearchComponent } from './product-search/product-search.component';
import { ProductTagsComponent } from './product-tags/product-tags.component';
import { TabDirectionToggleComponent } from './tab-direction-toggle/tab-direction-toggle.component';

const STOCKS_COMPONENTS = [
  ProductSearchComponent,
  BatchAddProductDialogComponent,
  ProductTagsComponent,
  TabDirectionToggleComponent,
  BatchSelectComponent,
  BatchAllocateDialogComponent,
  NewBatchDialogComponent,
  BatchStopIconComponent
];

@NgModule({
  declarations: STOCKS_COMPONENTS,
  imports: [SharedModule],
  exports: STOCKS_COMPONENTS
})
export class StocksSharedModule { }
